import script from "./FormVagasView.vue?vue&type=script&setup=true&lang=js"
export * from "./FormVagasView.vue?vue&type=script&setup=true&lang=js"

import "./FormVagasView.vue?vue&type=style&index=0&id=6cf840c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cf840c4"]])

export default __exports__